// extracted by mini-css-extract-plugin
export default {"wrapper":"InvoiceTab_wrapper__NHQnf","section":"InvoiceTab_section__2THRg"};